module.exports = __webpack_public_path__ + "img/menu_bottom_15.7c772a66.svg";